/**
 * Press Entry Carousel Web Component
 * Light DOM wrapper around Swiper for a single full-width, 1-slide-per-view
 * image carousel. Handles its own lifecycle (init/destroy) so it plays
 * nicely with Shopify theme editor re-renders.
 */
class PressEntryCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.handleShopifyEvent = this.handleShopifyEvent.bind(this);
  }

  connectedCallback() {
    this.init();
    this.bindShopifyEvents();
  }

  disconnectedCallback() {
    this.destroy();
    this.unbindShopifyEvents();
  }

  init() {
    if (this.swiper || typeof Swiper === "undefined") return;

    const container = this.querySelector(".swiper");
    if (!container) return;

    const slideCount = container.querySelectorAll(".swiper-slide").length;
    if (slideCount < 2) return;

    this.swiper = new Swiper(container, {
      slidesPerView: 1,
      loop: true,
      speed: 500,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: this.querySelector(".press-entry__carousel-nav--prev"),
        nextEl: this.querySelector(".press-entry__carousel-nav--next"),
      },
      pagination: {
        el: this.querySelector(".press-entry__carousel-pagination"),
        clickable: true,
      },
    });
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  bindShopifyEvents() {
    document.addEventListener("shopify:section:load", this.handleShopifyEvent);
    document.addEventListener("shopify:section:reorder", this.handleShopifyEvent);
    document.addEventListener("shopify:block:select", this.handleShopifyEvent);
  }

  unbindShopifyEvents() {
    document.removeEventListener("shopify:section:load", this.handleShopifyEvent);
    document.removeEventListener("shopify:section:reorder", this.handleShopifyEvent);
    document.removeEventListener("shopify:block:select", this.handleShopifyEvent);
  }

  handleShopifyEvent(event) {
    const targetId = event.detail?.sectionId || event.detail?.blockId;
    if (!targetId) return;

    const sectionId = this.dataset.sectionId;
    const blockId = this.dataset.blockId;
    if (targetId !== sectionId && targetId !== blockId) return;

    this.destroy();
    this.init();
  }
}

if (!customElements.get("press-entry-carousel")) {
  customElements.define("press-entry-carousel", PressEntryCarousel);
}
